// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_uAV","footer":"styles_footer__CIu-p"};